/*
 * (c) Copyright, 2026, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * EOS Form Validation Schema
 *
 * Migrated from: lego/page/eos/overview/StatusDocuments/FormValidation.jsx
 */

import * as yup from 'yup'

const EOS_LEVEL = {
  STUDY: 'STUDY',
  COUNTRY: 'COUNTRY',
  SITE: 'SITE'
} as const

const EosFormValidationSchema = () => {
  return yup.object().shape({
    filter: yup.object().shape({
      data: yup.object().shape({
        level: yup
          .string()
          .oneOf(Object.values(EOS_LEVEL))
          .default(() => EOS_LEVEL.STUDY),
        study: yup.number().min(1, 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR').required(),
        countries: yup.mixed().when('level', {
          is: (level: string) => level === EOS_LEVEL.COUNTRY || level === EOS_LEVEL.SITE,
          then: (schema: any) =>
            schema
              .transform((value: unknown) =>
                value === null
                  ? 'null'
                  : typeof value === 'string' || (typeof value === 'number' && value > 1)
                    ? value
                    : undefined
              )
              .required()
        }),
        sites: yup.mixed().when('level', {
          is: (level: string) => level === EOS_LEVEL.SITE,
          then: (schema: any) =>
            schema
              .transform((value: unknown) =>
                value === null
                  ? 'null'
                  : value === 'Undefined' || (typeof value === 'number' && value > 1)
                    ? value
                    : undefined
              )
              .required()
        }),
        activity: yup.string().required('GENERAL_FORM_FIELD_IS_REQUIRED_ERROR')
      })
    })
  })
}

export default EosFormValidationSchema
